import script from "./TaskDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__